import { Box, Flex } from '@chakra-ui/react';
import LaunchdeckCloseButton from '../helper-components/components/LaunchdeckCloseButton';
import StripeCheckoutButton from '../../../payments/components/StripeCheckoutButton';
import { useLocation } from 'react-router-dom';
import { displayEmoji } from '../../../digital-sales-room/helpers/dsr-helpers';


export default function SubscriptionNudgeBanner({
	handleCloseBanner,
	updateUserSettings,
	offerFreeTrial,
	freeTrialCode,
	isUndismissable
}) {

	const location = useLocation();
	const redirectBackRoute = location ? location.pathname : "/home";

	const handleDismissBanner = () => {
		if (!isUndismissable) {
			updateUserSettings({
				updatedBannerSettings: {
					bannerType: "org-admin-subscribe-reminder",
					doNotShowBanner: true
				}
			})
		}

		handleCloseBanner()
	}

	const titleCopy = `30-day free promo code`
	const textCopy = `Unlimited Rooms, detailed sales analytics & team collaboration tools - Get started for $0. `

	return (
		<Flex w='100%' position='relative' direction='column' bg='white' border='1px solid' borderColor='yellow.400' rounded='0.5em' p='0.5em 1em' justify='flex-start' mb='1.5em'>
			<Box position='absolute' top='0.5em' right='0.5em' visibility={isUndismissable ? "hidden" : ""} onClick={() => handleDismissBanner()}> <LaunchdeckCloseButton /></Box>
			<Flex gap='0.5em' align='center' justify={['center', 'flex-start']}>
				{offerFreeTrial
					?
					<Box fontSize='1.2em'>{displayEmoji('gift')}</Box>
					:
					<Box fontSize='1.2em'>
						{displayEmoji('label')}
					</Box>
				}
				<Box my={['1em', '0.5em']} letterSpacing='1px' fontWeight='600' fontSize='1.1em' color='brand.500' textAlign={['center', 'left']}>{freeTrialCode || "LAUNCHNOW24"}</Box>
			</Flex>

			<Box fontSize='0.9em' fontWeight='semibold' color='brandDark.500' textAlign={['center', 'left']}>{titleCopy}</Box>
			<Flex direction={['column', 'row']} gap='1.5em' w='100%' justify='flex-start' align='center' fontSize='0.875em' pb='0.5em'>
				<Box color='brandDark.500' textAlign={['center', 'left']}>{textCopy}</Box>
				<Box >	<StripeCheckoutButton sourceRoute={redirectBackRoute} isFreeTrial={offerFreeTrial} buttonText={'Use Code'} /></Box>
			</Flex>
		</Flex>
	);

}

